import {CANVAS_DATE_DAYS_OFFSET_FIRST_WEEK} from './canvas_timeline_util';

export const getWeekDayIndexFromCanvasDate = canvasTimelineDate => {
	return (canvasTimelineDate - CANVAS_DATE_DAYS_OFFSET_FIRST_WEEK) % 7;
};
